export default {
  getOwlExports: state => state.owlExports,
  getOwlExportsLoading: state => state.owlExportsLoading,
  getCreateExportLoading: state => state.createExportLoading,
  getShowExportTooltip: state => state.showExportTooltip
}
